import { createApi } from '@reduxjs/toolkit/query/react'
import { createAdminBaseQuery } from '../../../Utils/baseQuery'

export const neighborhoodApiService = createApi({
  reducerPath: 'neighborhoodApi',
  baseQuery: createAdminBaseQuery('/neighborhood/'),
  endpoints: (builder) => ({
    getNeighborhoods: builder.query({
      query: () => 'list',
      keepUnusedDataFor: 0
    }),
    getNeighborhoodById: builder.query({
      query: (id) => `get/${id}`,
      keepUnusedDataFor: 0
    }),
    createNeighborhood: builder.mutation({
      query: (payload) => ({
        url: 'create',
        method: 'POST',
        body: payload
      })
    }),
    updateNeighborhood: builder.mutation({
      query: ({ id, payload }) => ({
        url: `update/${id}`,
        method: 'PUT',
        body: payload
      })
    }),
    changeNeighborhoodStatus: builder.mutation({
      query: ({ id, status }) => ({
        url: `status/${id}`,
        method: 'PATCH',
        body: { status }
      })
    })
  })
})

export const {
  useGetNeighborhoodsQuery,
  useLazyGetNeighborhoodsQuery,
  useGetNeighborhoodByIdQuery,
  useCreateNeighborhoodMutation,
  useUpdateNeighborhoodMutation,
  useChangeNeighborhoodStatusMutation
} = neighborhoodApiService

